<template>
  <page-layout class="article_detail">

    <sub-page-layout no-border no-right-padding-top>

      <div class="con_wrapper">

        <div class="blockContainer">

          <div class="con_detail">
            <!-- 상세 상단 -->
            <div class="detail_top" v-show="loaded">
              <div class="data">
                <p class="subj" v-if="post.post_cate.idx !== 33 && post.post_cate.idx !== 34">{{post.title}}</p>
                <p class="date_area">
                  <router-link :to="`/news/cate/${post.post_cate.idx}`" class="ctry_title" :style="post.post_cate.color ? `color: ${post.post_cate.color}` : null">{{post.post_cate.name}}</router-link>
                  <i class="date">{{post.pub_dt}}</i>
                  <i class="date_latest">Last Updated {{post.mod_dt}}</i>
                  <router-link :to="`/article/editor/${post.writer.idx}`" class="editor">
                    <i class="img"><img v-if="isFileExist(post.writer.prof_img)" :src="post.writer.prof_img.url"></i>
                    <i class="name">{{post.writer.nick}}</i>
                  </router-link>
                </p>
              </div>
            </div>
          </div>

        </div>

        <div class="detail_con blockC">
          <!-- 컨텐츠 노출 영역 -->
          <!--<div class="con_view" v-html="post.contents"></div>-->
          <div class="con_view" id="con_view">
            <p v-if="post.post_cate.idx == 144" class="gto top">
              <a href="http://gtowizard.com/p/bluff&catch" target="_blank"><img src="https://cdn.bluffcatch.com/kr/post/1/contents/40331/Contents_Top_Banner.jpg"></a>
            </p>
            <!--<a class="telegram" href="https://t.me/bluffandcatch" target="_blank">
              <p class="img"><img src="https://cdn.bluffcatch.com/tournament/68/info/1615/telegram.png"></p>
              <p><b>Bluff&amp;Catch</b> 기사를 가장 빠르게 볼 수 있는 방법!<i class="enter"><span> 공식텔레그램 채널 구독♠</span><b> No Bluff ! No Future !</b></i></p>
            </a>-->

            <!--<p v-if="post.post_cate.idx == 54 && this.getAccess === 'mobile'">
              <a href="https://maxvaluepoker.io" target="_blank"><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37829/tips_mv_top_mo.jpg"></a>
            </p>

            <p v-if="post.post_cate.idx == 54 && this.getAccess === 'pc'">
              <a href="https://maxvaluepoker.io" target="_blank"><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37830/tips_mv_top_pc.jpg"></a>
            </p>-->
            <div v-html="replaceToHTML()"></div>
            <!--<a class="telegram" href="https://t.me/bluffandcatch" target="_blank">
              <p class="img"><img src="https://cdn.bluffcatch.com/tournament/68/info/1615/telegram.png"></p>
              <p><b>Bluff&amp;Catch</b> 기사를 가장 빠르게 볼 수 있는 방법!<i class="enter"><span> 공식텔레그램 채널 구독♠</span><b> No Bluff ! No Future !</b></i></p>
            </a>-->
            <p v-if="post.post_cate.idx == 54 && this.getAccess === 'mobile'">
              <a href="https://maxvaluepoker.io" target="_blank"><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37718/tips_MO_KOR.png"></a>
            </p>
            <p v-if="post.post_cate.idx == 54 && this.getAccess === 'pc'">
              <a href="https://maxvaluepoker.io" target="_blank"><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/37719/tips_PC_KOR.png"></a>
            </p>
            <p v-if="post.post_cate.idx == 144" class="gto btm">
              <a href="http://gtowizard.com/p/bluff&catch" target="_blank"><img src="https://cdn.bluffcatch.com/kr/post/1/contents/40331/Contents_Top_Banner.jpg"></a>
            </p>
          </div>
          <!-- copyright -->
          <div class="copy">Copyright ⓒ Bluff&amp;Catch. All rights reserved. <span>무단 전재 및 재배포 금지.</span></div>

          <!-- 해시태그 -->
          <div class="tag" v-if="post.post_cate.idx !== 33 && post.post_cate.idx !== 34">
            <p class="h_tags" v-if="post.tags">
              <i class="tit">TAGs</i>
              <router-link :to="`/article/tag/${tag}`" v-for="(tag, index) in post.tags" :key="index">{{tag}}</router-link>
            </p>
          </div>

          <!-- 에디터 -->
          <div class="editor" v-if="post.writer">
            <p class="img"><img v-if="isFileExist(post.writer.prof_img)" :src="getFileExist(post.writer.prof_img)"></p>
            <p class="name">{{post.writer.nick}}</p>
            <p class="position">{{post.writer.position}}</p>
            <router-link :to="`/article/editor/${post.writer.idx}`">Read More</router-link>
          </div>

          <a href="javascript:" @click="hasHistory() ? $router.go(-1) : $router.push(`/news/cate/${post.post_cate.idx}`)" class="list_btn" replace><i class="icon"></i>View List</a>
        </div>

      </div>

      <!-- 연관 콘텐츠 -->
      <div class="related_con">
        <div v-if="post.recommends && post.recommends[0] && post.recommends[0].idx">
          <div class="title">
            <h3>Related Articles</h3>
          </div>
          <ul class="lst">
            <li v-for="(rcmd, index) in post.recommends" :key="index" v-if="rcmd.idx">
              <router-link :to="`/article/${rcmd.idx}`">
                <p class="img"><img v-if="isFileExist(rcmd.post_img)" :src="getFileExist(rcmd.post_img)" class="fit_img"></p>
                <p class="category" :style="`color: ${rcmd.post_cate.color}`">{{rcmd.post_cate.name}}</p>
                <p class="subj">{{rcmd.title}}</p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>

    </sub-page-layout>
  </page-layout>
</template>

<script>
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import forms from './post_forms'
	import {Dialog, Popover} from 'element-ui'
  import {QDialog, QBtn, QBtnGroup, Loading, QSlideTransition, QDate, QCard, QSeparator} from 'quasar'
  const baseAction = '/posts'
  export default {
    name: 'Article',
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
			QDialog, QBtn, QBtnGroup, QCard, QDate, QSeparator,
      [Dialog.name]: Dialog,
      [Popover.name]: Popover,
      Loading,
      QSlideTransition,
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | ${this.getPostTitle}`,
        titleTemplate: '%s',
        meta: this.getSeoMeta
      }
    },
    data () {
      return {
        baseAction: baseAction,
        loaded: false,
        idx: '',
        post: forms,
        test: `%%container%%`,
      }
    },
		activated () {
      this.getPostData()
      // let recaptchaScript = document.createElement('script')
			// recaptchaScript.setAttribute('src', 'https://developers.kakao.com/sdk/js/kakao.js')
			// document.head.appendChild(recaptchaScript)
    },
    beforeRouteUpdate (to, from, next) {
      if (from.params.idx !== to.params.idx) {
        next()
        this.getPostData()
      } else {
        next(false)
      }
    },
		mounted () {
			// let recaptchaScript = document.createElement('script')
			// recaptchaScript.setAttribute('src', '/statics/event.js')
			// document.head.appendChild(recaptchaScript)
    },
    computed: {
      ...CommonComputed,
      getPostIdx () {
        return this.$route.params.idx
      },
			getAccess () {
        return 'pc'
      },
		 	isOpenShareDialog: {
        get () {
          return this.$store.getters.isOpenShareDialog
        },
        set (flag) {
          this.$store.dispatch('setOpenShareDialog', flag)
        }
      },
      getPostTitle () {
        return this.post && this.post.title ? this.post.title : ''
      },
      getSeoMeta () {
        return this.tournament ? this.tournament.seo_meta : []
      }
    },
    methods: {
      ...CommonMethods,
      getPostData () {
        this.idx = this.getPostIdx
        if (!this.idx) return

        // view_cnt 업데이트
        this.$axios.put(baseAction + '/view_cnt/' + this.idx)

        // content 가져오기
        this.$axios.get(baseAction + '/' + this.idx).then(rs => {
          this.post = rs.data

          this.$store.dispatch('setCurrentContentsData', rs.data)
          this.loaded = true
        }).catch(() => {
          this.$router.push('/')
          // setTimeout(function() {
          //   this.$router.replace('/contents')
          // }.bind(this), 200)
        })
      },
      replaceToHTML () {
        return this.post.contents.replace(//g,'')
      },
			toggleShareDialog (flag) {
        this.$store.dispatch('setOpenShareDialog', flag)
      },
      hasHistory () {
        return window.history.length > 2
      }
    },
  }
</script>

<style scoped>
  .con_wrapper {
    width: 700px;
    margin: 0 auto;
    padding-bottom: 100px;
  }
  .detail_top .data {
    position: relative;
    padding-bottom: 20px;
    margin-bottom: 50px;
    border-bottom: 1px solid #e5e5e5;
  }
  .detail_top .subj {
    font-size: 32px;
    color: #000;
    font-weight: 900;
    line-height: 1.4em;
    letter-spacing: -0.035em;
  }
  .detail_top .date_area {
    font-size: 14px;
    margin-top: 25px;
    font-weight: 500;
    line-height: 2.5em;
  }
  .detail_top .date_area .ctry_title {
    display: inline-block;
    color: #000;
    margin-right: 35px;
    transition: .15s;
  }
  .detail_top .date_area .ctry_title:hover {
    color: #379339;
    text-decoration: underline;
  }
  .detail_top .date_area i {
    color: #777;
  }
  .detail_top .date_area .date_latest {
    color: #777;
    border-left: 1px solid #bbb;
    padding-left: 15px;
    margin-left: 15px;
    margin-right: 35px;
  }
  .detail_top .date_area .editor {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
  }
  .detail_top .date_area .editor .img {
    display: inline-block;
    width: 32px;
    height: 32px;
    border-radius: 100%;
    overflow: hidden;
    padding-left: 0;
  }
  .detail_top .date_area .editor .img img {
    width: 100%;
    height: 100%;
  }
  .detail_top .date_area .editor .name {
    font-weight: 800;
    color: #000;
    transition: .15s;
    padding-left: 8px;
  }
  .detail_top .date_area .editor:hover .name {
    color: #379339;
    text-decoration: underline;
  }

  .detail_con {
    padding: 0;
  }
  .detail_con .con_view {
    font-size: 16px;
    line-height: 1.9em;
    color: #000;
    word-break: break-all;
    padding-bottom: 100px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
  }
  /deep/ .detail_con .con_view .os_poll {
    margin-top: -40px;
  }
  .detail_con .con_view .gto a {
    display: inline-block;
  }
  .detail_con .con_view .gto.top {
    margin-bottom: 50px;
  }
  .detail_con .con_view .gto.btm {
    margin-top: 60px;
  }
  .detail_con .tag {
    position: relative;
    padding-left: 60px;
  }
  .detail_con .tag .h_tags  {
    font-size: 16px;
    font-weight: 500;
  }
  .detail_con .tag .h_tags .tit {
    color: #000;
    font-weight: 800;
    position: absolute;
    left: 0;
  }
  .detail_con .tag .h_tags a {
    display: inline-block;
    margin: 0 12px 12px;
    color: #379339;
    border-bottom: 1px solid #379339;
  }
  .detail_con .tag .h_tags a:hover {
    color: #000;
    border-color: #000;
  }

  .detail_con .editor {
    padding: 20px;
    background: #ebebeb;
    font-size: 14px;
    margin: 35px 0;
    display: flex;
    align-items: center;
    position: relative;
    border-radius: 8px;
  }
  .detail_con .editor .img {
    display: inline-block;
  }
  .detail_con .editor .img img {
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }
  .detail_con .editor p {
    display: inline-block;
    margin: 0 10px;
  }
  .detail_con .editor p.name {
    font-weight: 800;
  }
  .detail_con .editor p.position {
    border-left-color: #888;
  }
  .detail_con .editor a {
    position: absolute;
    right: 30px;
    font-weight: 700;
    color: #000;
    text-decoration: underline;
  }
  .detail_con .editor a:hover {
    color: #379339;
  }
  .detail_con .copy {
    font-size: 0.9em;
    font-weight: 700;
    color: #000;
    margin-bottom: 50px;
    line-height: 1.0em;
  }
  .detail_con .telegram {
    padding: 15px 18px;
    background: #fff;
    border-radius: 10px;
    margin: 35px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .detail_con .telegram .img {
    display: inline-block;
  }
  .detail_con .telegram .img img {
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }
  .detail_con .telegram p {
    display: inline-block;
    font-size: 14px;
    margin: 0 10px;
    color: #000;
  }
  .detail_con .telegram p span {
    font-weight: 700;
    color: #1e94d3;
  }
  .detail_con /deep/.ad_article {
    padding: 60px 20px 20px;
    background: #fff;
    display: inline-block;
    margin: 40px 0;
    position: relative;
  }
  .wallpaper .detail_con /deep/.ad_article {
    border: 1px solid #ddd;
  }
  .detail_con /deep/.ad_article img {
    width: 100%;
  }
  .detail_con /deep/.ad_article:before {
    content: "Advertisement";
    position: absolute;
    top: 15px;
    left: 20px;
    font-size: 0.9em;
    color: #333;
    line-height: 1.0em;
    padding: 7px 10px;
    border-radius: 5.0em;
    background: #f1f1f1;
  }
  .related_con {
    border-top: 1px solid #000;
  }
  .related_con .title {
    margin: 20px 0;
    width: 860px;
  }
  .related_con h3 {
    font-size: 24px;
    font-weight: 900;
    color: #000;
    line-height: 1.6em;
    letter-spacing: -0.02em;
    display: inline;
  }
  .related_con h3:before {
    content: "";
    display: inline-block;
    width: 30px;
    height: 33px;
    background: url('/statics/img/bi_title.png') no-repeat;
    background-size: contain;
    margin-right: 14px;
  }
  .related_con .lst > li {
    display: inline-block;
    width: 299px;
    min-height: 260px;
    padding: 0 20px 0 19px;
    margin-bottom: 32px;
    border-right: 1px solid #e5e5e5;
  }
  .related_con .lst > li:nth-child(3n+1) {
    padding-left: 0;
    width: 280px;
  }
  .related_con .lst > li:nth-child(3n+3) {
    padding-right: 0;
    width: 280px;
    border-right: none;
  }
  .related_con .lst > li .img {
    position: relative;
    height: 220px;
    border-radius: 8px;
    overflow: hidden;
  }
  .related_con .lst > li .category {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.0em;
    margin-top: 20px;
  }
  .related_con .lst > li .subj {
    font-size: 16px;
    font-weight: 600;
    color: #000;
    line-height: 1.45em;
    letter-spacing: -0.02em;
    word-break: break-all;
    margin-top: 12px;
    max-height: 4.3em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    transition: .15s;
  }
  .related_con .lst > li a:hover .subj {
    color: #379339;
  }
  .list_btn {
    display: block;
    text-align: center;
    width: 40%;
    padding: 15px 0;
    margin: 50px auto 0;
    font-size: 20px;
    color: #222;
    font-weight: 700;
    letter-spacing: -0.5px;
    border: 1px solid #ccc;
    border-radius: 8px;
    transition: all 0.15s;
  }
  .list_btn:hover {
    color: #379339;
    border-color: #379339;
  }


  /* 콘텐츠 내 강제 지정 스타일 */
  /deep/ .con_view .card {
    font-size: 14px;
    font-weight: 900;
    padding: 0 3px;
    border: 1px solid #ccc;
    border-radius: 3px;
    background: #fff;
    margin: 2px;
  }
  /deep/ .con_view .card.black {
    color: #000;
  }
  /deep/ .con_view .card.red {
    color: #de0000;
  }
  /deep/ .con_view span a, /deep/ .con_view div a, /deep/ .con_view table a {
    color: #379339 !important;
    font-weight: 700;
    text-decoration: underline;
  }
  /deep/ .con_view span a img, .con_view div a img {
    background: #fff;
  }
  /deep/ .con_view span a:hover, /deep/ .con_view div a:hover, /deep/ .con_view table a:hover {
    color: #000 !important;
  }
  /deep/ .con_view span a u, .con_view div a u, .con_view a u {
    text-decoration: none !important;
  }
  /deep/ .con_view table {
    margin: 5px 0;
  }
  /deep/ .con_view table td {
    width: fit-content !important;
    padding: 12px 20px;
    background: #fff;
    font-size: 0.9em;
    font-weight: 500;
    line-height: 1.4em;
		vertical-align: middle;
    border-bottom: 1px solid #eee;
  }
  /deep/ .con_view table tr:first-child td {
    color: #379339;
    border-top: 1px solid rgba(55,147,57,0.35);
  }
  /deep/ .con_view table tr:nth-child(even) td {
    background: #fbfbfb;
  }
  /deep/ .con_view p.box {
    display: block;
    font-size: 0.9em;
    padding: 20px 30px;
    line-height: 1.8em;
    background: #eee;
    border: none;
  }
  /deep/ .con_view a.btn_article {
    display: inline-block;
    width: 75%;
    padding: 14px;
    border-radius: 10px;
    background: #008c03;
    font-size: 1.3em;
    font-weight: 400;
    color: #fff !important;
    text-align: center;
    text-decoration: none;
    line-height: 1.4em;
    position: relative;
    left: 50%;
    transform: translate(-50%, 0);
  }
  /deep/ .con_view a.btn_article:hover {
    color: #fff !important;
    background: #006702;
  }
  /deep/ .con_view a.btn_article:after {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    border: solid #fff;
    border-width: 2px 2px 0 0;
    position: absolute;
    right: 8%;
    top: 50%;
    transform: rotate(45deg) translate(0, -75%);
  }
	/deep/ .con_view img {
    width: 100%;
    border-radius: 8px;
	}
	/deep/ .con_view .mv_answer {
    display: inline-block;
    width: 100%;
    background: rgba(0,0,0,0.9);
    text-align: center;
    font-weight: 800;
    color: #dfb04c;
    padding: 15px;
    border-radius: 8px;
	}
	/deep/ .con_view .mv_answer:after {
    content: "➟";
    position: absolute;
    display: inline-block;
    transform: rotate(90deg);
    margin-left: 5px;
    color: #dfb04c;
	}
	/deep/ .con_view .mv_ctnr {
    display: inline-block;
    padding: 30px;
    background: rgba(0,0,0,0.03);
    margin: 50px 0;
    border-radius: 8px;
	}
	/deep/ .con_view .mv_ctnr h5 {
    font-weight: 700;
    margin-bottom: 15px;
	}
  /* max value coach container */
  /deep/ .con_view .mv_coach {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 180px;
    font-size: 15px;
    color: #ccc;
    line-height: 1.0em;
    background-color: #242424;
    background-size: 220px auto;
    background-repeat: no-repeat;
    background-position: 36% 100%;
    padding: 30px;
    margin-bottom: 10px;
	}
  /deep/ .con_view .mv_coach:before {
    content: "";
    display: inline-block;
    width: 26px;
    height: 26px;
    background: url(https://cdn.bluffcatch.com/kr/post/28/contents/35844/mv_logo.png) no-repeat;
    background-size: contain;
    position: absolute;
    left: 30px;
    bottom: 30px;
	}
  /deep/ .con_view .mv_coach .name {
    font-size: 24px;
    font-weight: 700;
    color: #ffcc41;
	}
  /deep/ .con_view .mv_coach .name:before {
    content: "COACH";
    display: block;
    font-size: 11px;
    font-weight: 800;
    color: #fff;
    line-height: 1.0em;
    margin-bottom: 14px;
	}
  /deep/ .con_view .mv_coach ul {
    position: absolute;
    top: 30px;
    right: 30px;
	}
  /deep/ .con_view .mv_coach ul li {
    line-height: 1.2em;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
	}
  /deep/ .con_view .mv_coach ul li:before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 4px;
    background: #555;
    border-radius: 100%;
    margin-right: 8px;
	}
  /deep/ .con_view .mv_coach ul li:first-child:after {
    content: "*";
    font-size: 10px;
    position: relative;
    top: -5px;
	}
  /deep/ .con_view .mv_coach em {
    position: absolute;
    right: 15px;
    bottom: 15px;
    font-size: 12px;
    font-weight: 600;
    font-style: normal;
    color: rgba(255,255,255,0.3);
    line-height: 1.0em;
	}
  /deep/ .con_view .mv_coach.alex {
    background-image: url(https://cdn.bluffcatch.com/kr/post/28/contents/35833/coach_alex.png);
	}
  /deep/ .con_view .mv_coach.chance {
    background-image: url(https://cdn.bluffcatch.com/kr/post/28/contents/35836/coach_chance.png);
	}
  /deep/ .con_view .mv_coach.daniel {
    background-image: url(https://cdn.bluffcatch.com/kr/post/28/contents/35837/coach_daniel.png);
	}
  /deep/ .con_view .mv_coach.joseph {
    background-image: url(https://cdn.bluffcatch.com/kr/post/28/contents/35838/coach_joseph.png);
	}
  /deep/ .con_view .mv_coach.steve {
    background-image: url(https://cdn.bluffcatch.com/kr/post/28/contents/35839/coach_steve.png);
	}
	/deep/ img[name^="target_resize_image[]"] {
		margin: 0 auto;
		display: block;
		max-width: 760px;
	}
	/deep/ .m-show {
		display: none;
	}
  /deep/ .fr-video { display: block !important; position: relative !important; height: 0 !important; padding-bottom: 56.25% !important; }
  /deep/ .fr-video iframe { position: absolute !important; width: 100% !important; height: 100% !important; top:0; left: 0; }
  /deep/ [data-f-id="pbf"] {
    display: none;
  }
</style>
